export default "__VITE_ASSET__80d24d9e__"